import React from "react";

// Roadmap
const Roadmap = ({ language }) => {
  return (
    <React.Fragment>
      <main className="roadmap-page">
        <section className="hero">
          <div className="container">
            <h1>
              <span>\\</span> The Ultimate Roadmap <span>//</span>
            </h1>

            <div className="phases">
              <div className="phase phase-left-content">
                <img
                  src="../../images/pages/roadmap/hero-img-1.webp"
                  alt=""
                  className="right-face-img"
                />

                <div className="content-box">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>
                        1st Whitelist (1,500 NFTs)
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        1차 화이트리스트(1,500 NFT)
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        第一个白名单（1,500 个 NFT）
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Danh sách trắng đầu tiên (1.500 NFT)
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        القائمة البيضاء الأولى (1500 NFTs)
                      </React.Fragment>
                    ) : null}
                  </h3>

                  <p className="text">
                    {language === "english" ? (
                      <React.Fragment>
                        1. Start 1st whitelist on the BCL website <br />{" "}
                        <span className="date">
                          August 16th - September 6th
                        </span>{" "}
                        <br />
                        <br /> 2. Deposit Deadline <br />{" "}
                        <span className="date">
                          August 16th - September 6th
                        </span>
                        <br />
                        <br />
                        3. Minting site added on BCL website <br />{" "}
                        <span className="date">
                          August 16th - August 19th
                        </span>{" "}
                        <br />
                        <br />
                        4. Release channel at OpenSea in the form of a gift box
                        <br /> <span className="date">October 7th</span> <br />
                        <br />
                        5. Random Hero Card Reveal <br />{" "}
                        <span className="date">October 7th</span>
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        1. BCL 웹사이트에서 1차 화이트리스트 시작 8월 16일 - 9월
                        6일 <br />
                        <br />
                        2. 입금 마감 8월 16일 - 9월 6일 <br />
                        <br />
                        3. BCL 웹사이트에 민팅사이트 추가 8월 16일 - 8월 19일{" "}
                        <br />
                        <br />
                        4. OpenSea에서 Gift box형태로 채널 출시 9월 5일 <br />
                        <br />
                        5. 랜덤 히어로카드 공개 9월 16일
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        1.在BCL网站上启动第一个白名单 8 月 16 日 - 9 月 6 日{" "}
                        <br />
                        <br />
                        2. 存款截止日期 8 月 16 日 - 9 月 6 日 <br />
                        <br />
                        3. BCL网站新增造币站 8 月 16 日 - 8 月 19 日 <br />
                        <br />
                        4. OpenSea 以礼盒形式发布频道 9月5日 <br />
                        <br />
                        5. 随机英雄卡牌展示 9月16日
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        1. Bắt đầu danh sách trắng đầu tiên trên trang web BCL
                        16 tháng 8 - 6 tháng 9 <br />
                        <br />
                        2. Thời hạn gửi tiền 16 tháng 8 - 6 tháng 9 <br />
                        <br />
                        3. Trang web đúc tiền được thêm vào trang web BCL 16
                        tháng 8 - 19 tháng 8 <br />
                        <br />
                        4. Kênh phát hành tại OpenSea dưới dạng hộp quà Ngày 5
                        tháng 9 <br />
                        <br />
                        5. Tiết lộ thẻ anh hùng ngẫu nhiên Ngày 16 tháng 9
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        1. ابدأ القائمة البيضاء الأولى على موقع BCL 16 أغسطس - 6
                        سبتمبر 2. الموعد النهائي للإيداع 16 أغسطس - 6 سبتمبر 3.
                        إضافة موقع سك على موقع BCL 16 أغسطس - 19 أغسطس 4. قم
                        بتحرير القناة في OpenSea في شكل صندوق هدايا الخامس من
                        سبتمبر 5. كشف بطاقة البطل العشوائي 16 سبتمبر
                      </React.Fragment>
                    ) : null}
                  </p>
                </div>
              </div>

              <div className="phase phase-right-content">
                <img
                  src="../../images/pages/roadmap/hero-img-2.png"
                  alt=""
                  className="left-face-img"
                />

                <div className="content-box">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>
                        2nd Whitelist (3,000 NFTs)
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        2차 화이트리스트(3,000 NFT)
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>第二个白名单（3,000 NFT）</React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Danh sách trắng thứ hai (3.000 NFT)
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        القائمة البيضاء الثانية (3000 NFTs)
                      </React.Fragment>
                    ) : null}
                  </h3>

                  <p className="text">
                    {language === "english" ? (
                      <React.Fragment>
                        1. Start 2nd whitelist on the BCL website <br />{" "}
                        <span className="date">October 8th - October 23th</span>
                        <br />
                        <br /> 2. Deposit Deadline(BCL&other payment) <br />{" "}
                        <span className="date">
                          October 8th - October 25th
                        </span>{" "}
                        <br />
                        <br />
                        3. Release channel at OpenSea in the form of a gift box
                        <br /> <span className="date">October 26th</span> <br />
                        <br />
                        4. Random Hero Card Reveal <br />{" "}
                        <span className="date">September 25th</span>
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        1. BCL 웹사이트에서 2차 화이트리스트 시작 9월 14일 - 9월
                        27일 <br />
                        <br />
                        2. 입금마감(BCL&기타결제) 9월 14일 - 9월 27일 <br />
                        <br />
                        3. OpenSea에서 선물상자 형태로 채널 출시 9월 27일 <br />
                        <br />
                        4. 랜덤 히어로카드 공개 9월 29일
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        1.在BCL网站上启动第二个白名单 9 月 14 日 - 9 月 27 日{" "}
                        <br />
                        <br />
                        2. 存款期限（BCL&其他支付方式） 9 月 14 日 - 9 月 27 日
                        <br />
                        <br />
                        3. OpenSea 以礼盒形式发布频道 9月27日 <br />
                        <br />
                        4. 随机英雄卡牌展示 9月29日
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        1. Bắt đầu danh sách trắng thứ hai trên trang web BCL 14
                        tháng 9 - 27 tháng 9 <br />
                        <br /> 2. Thời hạn gửi tiền (BCL & thanh toán khác) 14
                        tháng 9 - 27 tháng 9 <br />
                        <br />
                        3. Kênh phát hành tại OpenSea dưới dạng hộp quà Ngày 27
                        tháng 9 <br />
                        <br />
                        4. Tiết lộ thẻ anh hùng ngẫu nhiên 29 tháng 9
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        BCL 14 سبتمبر - 27 سبتمبر 2. الموعد النهائي للإيداع (BCL
                        & مدفوعات أخرى) 14 سبتمبر - 27 سبتمبر 3. قم بتحرير
                        القناة في OpenSea على شكل صندوق هدايا 27 سبتمبر 4. كشف
                        البطل العشوائي 29
                      </React.Fragment>
                    ) : null}
                  </p>
                </div>
              </div>

              <div className="phase phase-left-content">
                <img
                  src="../../images/pages/roadmap/hero-img-3.png"
                  alt=""
                  className="right-face-img"
                />

                <div className="content-box">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>3rd whitelist(2,500 NFTs)</React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        3차 화이트리스트(2,500 NFT)
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>第三白名单（2,500 NFT）</React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Danh sách trắng thứ 3 (2.500 NFT)
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        القائمة البيضاء الثالثة (2500 NFTs)
                      </React.Fragment>
                    ) : null}
                  </h3>

                  <p className="text">
                    {language === "english" ? (
                      <React.Fragment>
                        1. Start 3rd whitelist on the BCL website <br />
                        <span className="date">
                          October 26th - November 8th
                        </span>
                        <br />
                        <br />
                        2. Deposit Deadline(BCL & other payment)
                        <br />
                        <span className="date">
                          October 26th - November 8th
                        </span>
                        <br />
                        <br /> 3. Release channel at OpenSea in the form of a
                        gift box <br />
                        <span className="date">November 8th</span>
                        <br />
                        <br /> 4. Random Hero Card Reveal <br />
                        <span className="date">November 10th</span>
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        1. BCL 웹사이트에서 3차 화이트리스트 시작 10월 4일 -
                        10월 18일 <br />
                        <br />
                        2. 입금 기한(BCL 및 기타 결제) 10월 4일 - 10월 18일{" "}
                        <br />
                        <br />
                        3. OpenSea에서 선물상자 형태로 채널 출시 10월 18일{" "}
                        <br />
                        <br />
                        4. 랜덤 히어로카드 공개 10월 20일
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        1.在BCL网站启动第三个白名单 10 月 4 日 - 10 月 18 日{" "}
                        <br />
                        <br />
                        2. 存款期限(BCL & other payment) 10 月 4 日 - 10 月 18
                        日 <br />
                        <br />
                        3. OpenSea 以礼盒形式发布频道 10月18日 <br />
                        <br />
                        4. 随机英雄卡牌展示 10月20日
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        1. Bắt đầu danh sách trắng thứ 3 trên trang web BCL 4
                        tháng 10 - 18 tháng 10 <br />
                        <br />
                        2. Thời hạn gửi tiền (BCL & thanh toán khác) 4 tháng 10
                        - 18 tháng 10 <br />
                        <br />
                        3. Kênh phát hành tại OpenSea dưới dạng hộp quà 18 tháng
                        10 <br />
                        <br />
                        4. Tiết lộ thẻ anh hùng ngẫu nhiên Ngày 20 tháng 10
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        1. ابدأ القائمة البيضاء الثالثة على موقع BCL 4 أكتوبر -
                        18 أكتوبر 2. الموعد النهائي للإيداع (BCL & مدفوعات أخرى)
                        4 أكتوبر - 18 أكتوبر 3. قم بتحرير القناة في OpenSea على
                        شكل صندوق هدايا 18 أكتوبر 4. كشف البطل العشوائي 20
                        أكتوبر
                      </React.Fragment>
                    ) : null}
                  </p>
                </div>
              </div>

              <div className="phase phase-right-content">
                <img
                  src="../../images/pages/roadmap/hero-img-4.png"
                  alt=""
                  className="left-face-img"
                />

                <div className="content-box">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>
                        Start Dutch Auction(1,000 NFTs)
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>더치옥션시작(1,000 NFT)</React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        开始荷兰式拍卖（1,000 NFT）
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Bắt đầu đấu giá Hà Lan (1.000 NFT)
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        بدء المزاد الهولندي (1،000 NFTs)
                      </React.Fragment>
                    ) : null}
                  </h3>

                  <p className="text">
                    <span className="date">
                      {language === "english" ? (
                        <React.Fragment>November 12th</React.Fragment>
                      ) : language === "korean" ? (
                        <React.Fragment>10월 26일</React.Fragment>
                      ) : language === "chinese" ? (
                        <React.Fragment>10月26日</React.Fragment>
                      ) : language === "vietnamese" ? (
                        <React.Fragment>Ngày 26 tháng 10</React.Fragment>
                      ) : language === "arabic" ? (
                        <React.Fragment>26 أكتوبر</React.Fragment>
                      ) : null}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <img
          src="../../images/body-bg-img-2.png"
          alt=""
          className="body-bg-img-1"
        />
      </main>
    </React.Fragment>
  );
};

// Export
export default Roadmap;
